module.exports = __webpack_public_path__ + "static/img/dq.460a086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dq.png
// module id = sKMG
// module chunks = 1